import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled, { keyframes } from 'styled-components';

var _templateObject, _templateObject2;
var fadeInAnimation = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"])));
var FadeInContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  animation-name: ", ";\n  animation-duration: ", ";\n  animation-timing-function: ease-in-out;\n"])), fadeInAnimation, function (_ref) {
  var $duration = _ref.$duration;
  return $duration;
});

export { FadeInContainer, FadeInContainer as default };
//# sourceMappingURL=FadeIn.styles.js.map
